import { render, staticRenderFns } from "./ConsentSignForm.vue?vue&type=template&id=9c6b3586&scoped=true&"
import script from "./ConsentSignForm.vue?vue&type=script&lang=ts&"
export * from "./ConsentSignForm.vue?vue&type=script&lang=ts&"
import style0 from "./ConsentSignForm.vue?vue&type=style&index=0&id=9c6b3586&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6b3586",
  null
  
)

export default component.exports